import { Theme, keyframes } from '@mui/material';
/**
 * style object for ccf-audio-player component
 * @returns CcfAudioPlayerStyle object
 * ```
 * @example
 * <CcfAudioPlayerStyle />
 * ```
 */
const CcfAudioPlayerStyle = (theme: Theme, conatinerWidth='150%', isInboundDirection=false, shouldShowCloseIcon: boolean) => {
  const spin = keyframes`
        0% {
        transform: scale(1);
    }
    15% {
        box-shadow: 0 0 0 5px rgba(52, 152, 219,0.1);
    }
    25% {
        box-shadow: 0 0 0 10px rgba(52, 152, 219,0.1), 0 0 0 20px rgba(52, 152, 219,0.1);
    }
    35% {
        box-shadow: 0 0 0 15px rgba(52, 152, 219,0.1), 0 0 0 30px rgba(52, 152, 219,0.1);
    }
    `;
  const styles = {
    mainContainer :{ 
      display: 'flex', 
      flexDirection: 'row', 
      width: conatinerWidth, 
      margin: '0.063rem', 
      borderRadius : '0.375rem', 
      height: '3.254rem' ,
    },
    audioHoldIcon:{
      fontSize: 10, 
      marginLeft: 0,
      color: theme?.palette?.background?.paper,
    },
    audioResumeIcon: {
      fontSize: 10,
      marginLeft: '0.3125rem',
      color: theme?.palette?.background?.paper,
    },
    fabButton:{
      height: '2.146rem', 
      width: '2.146rem',
      minHeight:'2.1rem',
      padding:'0.125rem 0 0 0.125rem',
      backgroundColor : theme?.palette?.background?.audioPlayerColor,
      '&:hover': {
        backgroundColor: theme?.palette?.background?.audioPlayerColor,
      },
    },
    recordInprogress:{
      position: 'absolute',
    },
    closeIcon: {
      color: theme?.palette?.primary?.secondary,
      fontSize: '1.25rem',
      cursor: 'pointer',
      marginRight: '0.5rem',
      marginLeft: '0.5rem',
      height: '1rem',
      width: '1rem',
    },
    audioPlayerPlayButton: {
      '& .rhap_button-clear': {
        overflow: 'visible',
        marginBottom: '0.625rem',
        borderRadius: '0.438rem',
      },
      '& .rhap_progress-indicator': {
        background: theme?.palette?.background?.audioPlayerColor,
        top:'-0.375rem',
        height: '0.875rem',
        width: '0.875rem',
        [theme.breakpoints.down('xs')]: {
          width: '0.575rem',
        },
      },
      '& .rhap_container': {
        borderRadius: '0.375rem',
        height: '3.254rem',
        padding: '0',
        [theme.breakpoints.down('md')]: {
          width: shouldShowCloseIcon ? '100%' : '90%',
        },
      },
      '& .rhap_progress-bar-show-download':{
        color: theme?.palette?.background?.audioPlayerColor,
        height: '0.125rem',
      },
      '& .rhap_time':{
        fontSize:'0.75rem',
      },
      '& .rhap_controls-section':{
        marginLeft: '0.25rem',
        flexGrow: 'revert',
      },
      '& .rhap_play-pause-button':{
        zIndex: '997',
        marginBottom: '0.938rem',
      },
    },
    circularProgress: {
      position: 'absolute',
      top: -6,
      left: -6,
      zIndex: 1,
      height: '2.208rem',
      width: '2.208rem',
      [theme.breakpoints.down('xl')]: {
        top: 0,
        left: 0,
        height: 38,
        width: 38,
      },
    },
    downloadIcon:{
      cursor: 'pointer',
      marginLeft: '0.5rem',
      marginRight: '0.5rem',
      color: theme?.palette?.background?.audioPlayerColor,
    },
    audioAttachmentContainer: {
      overflow: 'visible',
      backgroundColor: isInboundDirection? theme?.palette?.background?.slateGrey:theme?.palette?.background?.paper,
    },
    pulseAnimation:{
      margin: '8 0 0 8',
      background: theme?.palette?.primary?.main,
      width: '2.25rem',
      height: '2.313rem',
      position: 'relative',
      borderRadius: '90%',
      border: `solid 0.313rem ${theme?.palette?.background?.paper}`,
      animation: `${spin} 2s ease infinite`,
      '&::-webkit-backface-visibility': 'hidden',
      '&::-moz-backface-visibility': 'hidden',
      '&::-ms-backface-visibility': 'hidden',
      backfaceVisibility: 'hidden',
    },    
    recordTimer:{
      marginRight:'0.25rem',
    },
    tooltipArea:{
      width:'100%',
    },
    audioPlayerColor:{
      color: theme?.palette?.background?.audioPlayerColor,
    },
    fab: {
      position: 'relative',
      height: '2.5rem',
      width: '2.5rem',
      margin: '2 0 2 0',
      border:`0.1875rem  solid ${theme?.palette?.background?.darkGrey}`,
      backgroundColor: theme?.palette?.background?.audioPlayerColor,
      '&:hover': {
        backgroundColor: theme?.palette?.background?.audioPlayerColor,
      },
    },    
  };
  return styles;
};

export default CcfAudioPlayerStyle;
